import { Component } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { EMPTY, Observable, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { PurchaseOrderService } from "../purchase-order.service";

@Component({
  templateUrl: './purchase-order-needa.component.html'
})
export class PurchaseOrderNeedaComponent {
  public purchaseOrderNumber = 0;
  public type = "";
  public needaFile = "";

  constructor(
    private purchaseOrderService: PurchaseOrderService,
    private router: Router,
    activatedRoute: ActivatedRoute,
  ) {
    activatedRoute.paramMap.pipe(
      switchMap(paramMap => this.getNeedaFileByType(paramMap)),
    ).subscribe(needaFile => this.needaFile = needaFile);
  }

  public getNeedaFileByType(paramMap: ParamMap): Observable<string> {
    this.purchaseOrderNumber = +(paramMap.get("purchaseOrder") || 0);

    this.type = paramMap.get("type") || "";

    if (this.purchaseOrderNumber == 0 || this.type == "") {
      this.router.navigateByUrl("/404");

      return EMPTY;
    }

    return this.purchaseOrderService.getNeedaFileByType(this.purchaseOrderNumber, this.type);
  }
}